import { createRoutesFromElements, redirect, Route } from 'react-router-dom';
import { DefaultLayout } from 'layouts';
import { RequireAuth } from 'components';
import { Checkout } from 'pages';
import Releases from 'pages/Releases';
import {
  AllReleases,
  DraftReleases,
  PendingReleases,
  ReleasedReleases,
} from 'pages/Releases/lists';
import { locations } from './locations';

const releasesRoutes = createRoutesFromElements(
  <Route
    id="releases"
    path={locations.releases.routeSegment}
    element={
      <RequireAuth>
        <DefaultLayout hideFooter hasPlayer>
          <Releases />
        </DefaultLayout>
        <Checkout shouldBlockRedirect />
      </RequireAuth>
    }
  >
    <Route
      id="releases-index"
      index
      loader={() => redirect(locations.releases.all.route)}
    />
    <Route
      id="all"
      path={locations.releases.all.route}
      element={<AllReleases />}
    />
    <Route
      id="draft"
      path={locations.releases.draft.route}
      element={<DraftReleases />}
    />
    <Route
      id="pending"
      path={locations.releases.pending.route}
      element={<PendingReleases />}
    />
    <Route
      id="released"
      path={locations.releases.released.route}
      element={<ReleasedReleases />}
    />
  </Route>
);

export default releasesRoutes;
